import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';
import { BaseProvider } from '../providers/base-provider';

@Injectable()
export class ConsumerOfferManagerHandler extends BaseProvider {
  	businessId: any = 0; 
  	invoiceId: any = 0; 

  	selectedOffer: any={};
  	invoiceDetailList: any = [];

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){		
		super()
	}

	getOffersByBusinessId(params){	
	  	this.url = this.globals.dataUrl + 'consumerOffer/whiskey/' + this.globals.whiskeyId + '/businessId/' + params.businessId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

	getOffers(params){	
	  	this.url = this.globals.dataUrl + 'consumerOffer/whiskey/' + this.globals.whiskeyId +
										  '/v2/page/' + params.page +
										  '/size/' + params.size +
										  '/filter/' + params.filter;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
				if(params.page==1){
					this.list = res.Data;
				}else{
					this.pushItems(res.Data);	
				}

		        if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}  	

  	getAllOffers(params){	
	  	this.url = this.globals.dataUrl + 'consumerOffer/whiskey/' + this.globals.whiskeyId + '/all' +
										  '/page/' + params.page +
										  '/size/' + params.size +
										  '?term=' + params.term +
										  '&categories=' + params.categories;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
				if(params.page==1){
					this.list = res.Data;
				}else{
					this.pushItems(res.Data);	
				}

		       	if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getOffer(params){	
	  	this.url = this.globals.dataUrl + 'consumerOffer/whiskey/' + this.globals.whiskeyId + '/' + params.id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data[0]);
		    });   
    	})
  	}

  	getOfferMulti(params){	
	  	this.url = this.globals.dataUrl + 'consumerOffer/multi/' + params.id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
				this.invoiceDetailList = res.Data
				if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}  	

  	getOfferDetail(params){	
	  	this.url = this.globals.dataUrl + 'consumerOffer/whiskey/' + this.globals.whiskeyId + '/detail/' + params.id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data[0]);
		    });   
    	})
  	}  	

  	getOfferMedia(params){	
	  	this.url = this.globals.dataUrl + 'consumerOffer/media/' + params.id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getOfferByInvoiceDetail(params){
	  	this.url = this.globals.dataUrl + 'consumerOffer' +
										  '/multi/detail/' + params.id

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		        if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})  		
  	}

  	pickOfferToRedeem(){
  		var offer = {};
  		for (var i = 0; i < this.invoiceDetailList.length; ++i) {
  			if(this.invoiceDetailList[i].RedeemedDate==null){
  				offer = this.invoiceDetailList[i];
  				break;
  			}
  		}

  		return offer;
  	}

  	offerToRedeemCount(){
  		var count = 0;

  		for (var i = 0; i < this.invoiceDetailList.length; ++i) {
  			if(this.invoiceDetailList[i].RedeemedDate==null){
  				count++;;
  			}
  		}

  		return count;  		
  	}

  	offerRedeemCount(){
  		var count = 0;

  		for (var i = 0; i < this.invoiceDetailList.length; ++i) {
  			if(this.invoiceDetailList[i].RedeemedDate!=null){
  				count++;;
  			}
  		}

  		return count;  		
  	}
}



// WEBPACK FOOTER //
// ./src/providers/consumer-offer-handler.ts